type MxpLogoIconProps = {
  className?: string;
};

const LogoIcon = ({ className = '' }: MxpLogoIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 120 120 `}
      className={className}
    >
      <path
        d="M120 16v88c0 8-8 16-16 16H16c-8 0-16-8-16-16V16C0 8 8 0 16 0h88c8 0 16 8 16 16z"
        fill="#1d0638"
      />
      <path
        d="M100 34v72c0 8-6 14-14 14H14c-8 0-14-6-14-14V34c0-8 6-14 14-14h72c8 0 14 6 14 14z"
        fill="#1d4050"
      />
      <path
        d="M80 50v60c0 5-5 10-10 10H10c-5 0-10-5-10-10V50c0-5 5-10 10-10h60c5 0 10 5 10 10z"
        fill="#1e7b68"
      />
      <path
        d="M60 66v48c0 3-3 6-7 6H6c-3 0-6-3-6-6V66c0-3 3-6 6-6h47c4 0 7 3 7 6z"
        fill="#1eb57f"
      />
      <path
        d="M40 82v35c0 2-1 3-3 3H3c-2 0-3-1-3-3V82c0-1 1-2 3-2h34c2 0 3 1 3 2z"
        fill="#1eef97"
      />
    </svg>
  );
};

export default LogoIcon;
